import { render } from "./saveVille.vue?vue&type=template&id=71871f59&scoped=true"
import script from "./saveVille.vue?vue&type=script&lang=js"
export * from "./saveVille.vue?vue&type=script&lang=js"

import "./saveVille.vue?vue&type=style&index=0&id=71871f59&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71871f59"]])

export default __exports__